import emailjs from '@emailjs/browser';
import type { ContactFormData, EmailJSConfig } from '../types';
import { personalInfo } from '../data/personal';

// EmailJS configuration — values come from REACT_APP_EMAILJS_* env vars
const emailJSConfig: EmailJSConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID ?? '',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID ?? '',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY ?? ''
};

export class EmailService {
  private static instance: EmailService;
  private config: EmailJSConfig;

  private constructor() {
    this.config = emailJSConfig;
  }

  public static getInstance(): EmailService {
    if (!EmailService.instance) {
      EmailService.instance = new EmailService();
    }
    return EmailService.instance;
  }

  public async sendContactEmail(formData: ContactFormData): Promise<void> {
    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        to_email: personalInfo.email
      };

      await emailjs.send(
        this.config.serviceId,
        this.config.templateId,
        templateParams,
        this.config.publicKey
      );
    } catch (error) {
      console.error('EmailJS Error:', error);
      throw new Error('Failed to send email. Please try again later.');
    }
  }

  public updateConfig(newConfig: Partial<EmailJSConfig>): void {
    this.config = { ...this.config, ...newConfig };
  }

  public getConfig(): EmailJSConfig {
    return { ...this.config };
  }
}

// Export singleton instance
export const emailService = EmailService.getInstance(); 